<template>
  <PageContainer id="calculating">
    <div class="page-content no-button">
      <div class="top">
        <div class="title black">Your prize is being calculated!</div>

        <div class="container">
          <div class="progress">
            <div
              class="progress-bar progress-bar-warning progress-bar-striped"
              role="progressbar"
              :aria-valuenow="progressValue"
              aria-valuemin="10"
              aria-valuemax="100"
              :style="{width:progressValue + '%'}"
            >
              <span class="sr-only"></span>
            </div>
          </div>
        </div>
      </div>

      <div class="winners">
        <div class="winner hidden">
          <img class="slide-down winner-img-reg-13" :src="winner1Img" alt="A HealthyWager winner">
          <div class="text slide-up">
            {{winner1Name}} <br> won <span class="cash-value">{{winner1Value}}</span> for losing {{winner1Weight}}!
          </div>
        </div>
        <div class="winner hidden">
          <img class="slide-down winner-img-reg-13" :src="winner2Img" alt="A HealthyWager winner">
          <div class="text slide-up">
            {{winner2Name}} <br> won <span class="cash-value">{{winner2Value}}</span> for losing {{winner2Weight}}!
          </div>
        </div>
        <div class="winner hidden">
          <img class="slide-down winner-img-reg-13" :src="winner3Img" alt="A HealthyWager winner">
          <div class="text slide-up">
            {{winner3Name}} <br> won <span class="cash-value">{{winner3Value}}</span> for losing {{winner3Weight}}!
          </div>
        </div>
        <div class="winner hidden">
          <img class="slide-down winner-img-reg-13" :src="winner4Img" alt="A HealthyWager winner">
          <div class="text slide-up">
            {{winner4Name}} <br> won <span class="cash-value">{{winner4Value}}</span> for losing {{winner4Weight}}!
          </div>
        </div>
        <div class="winner hidden">
          <img class="slide-down winner-img-reg-13" :src="winner5Img" alt="A HealthyWager winner">
          <div class="text slide-up">
            {{winner5Name}} <br> won <span class="cash-value">{{winner5Value}}</span> for losing {{winner5Weight}}!
          </div>
        </div>
      </div>
    </div>

    <div class="footer-container">
      <ProgressBar />
    </div>
  </PageContainer>
</template>

<script>
import PageContainer from '../../shared/components/PageContainer';
import ProgressBar from '../../shared/components/ProgressBar';
import Trackeable from '../../Trackeable';
import Globalized from '../../shared/components/Globalized';
import { PRIZE_CHOICES_URL, STATIC_URL } from '../main';
import ProgressFull from '../mixins/ProgressFull';
import $ from 'jquery';
import {
  GENERIC_ERROR_MSG,
  isUserLoggedIn,
  POST_API_URL,
  mapFullStoreToParams,
  isEmptyData,
  alertAndRedirectToFunnelUrl
} from '../utils';
import { delayedTransition, ROUTE_NAMES } from '../router';

const PROGRESS_UPDATE = [10, 25, 5, 10, 40];

export default {
  components: {
    PageContainer,
    ProgressBar
  },
  mixins: [Trackeable, Globalized, ProgressFull],
  data: function() {
    return {
      interval: null,
      currentImageIndex: 0,
      winner1Img: `${STATIC_URL}img/spa/calculating/winner_beth_huff.png`,
      winner1Name: 'Beth H.',
      winner1Value: this.site().fullMoneyString(2279),
      winner1Weight: this.site().currentWeightString(35),
      winner2Img: `${STATIC_URL}img/spa/calculating/winner_carla_sheppard_bell.png`,
      winner2Name: 'Carla S.',
      winner2Value: this.site().fullMoneyString(1498),
      winner2Weight: this.site().currentWeightString(30),
      winner3Img: `${STATIC_URL}img/spa/calculating/winner_tracey_young.png`,
      winner3Name: 'Tracey Y.',
      winner3Value: this.site().fullMoneyString(1095),
      winner3Weight: this.site().currentWeightString(46),
      winner4Img: `${STATIC_URL}img/spa/calculating/winner_tabetha_m.png`,
      winner4Name: 'Tabetha M.',
      winner4Value: this.site().fullMoneyString(5200),
      winner4Weight: this.site().currentWeightString(53),
      winner5Img: `${STATIC_URL}img/spa/calculating/winner_josh_smith.png`,
      winner5Name: 'Josh S.',
      winner5Value: this.site().fullMoneyString(2020),
      winner5Weight: this.site().currentWeightString(72),
      progressValue: 10,
      redirectUrl: PRIZE_CHOICES_URL,
      calculatingProcess1: false,
      calculatingProcess2: false
    }
  },
  mounted: function() {
    this.showWinnersList();
    if (isUserLoggedIn()) {
      this.submitToAPI()
    } else {
      this.calculatingProcess1 = true;
    }
  },
  beforeDestroy: function() {
    clearInterval(this.interval);
  },
  computed: {
    shouldRedirect() {
      return this.calculatingProcess1 && this.calculatingProcess2;
    }
  },
  watch: {
    shouldRedirect(val) {
      if (val) {
        if (isUserLoggedIn()) {
          window.location.href = this.redirectUrl;
        } else {
          delayedTransition(this.$router, ROUTE_NAMES.Signup, 1500);
        }
      }
    }
  },
  methods: {
    showWinnersList() {
      const self = this;

      self.interval = window.setInterval(function() {
        const $winners = document.querySelectorAll('.winners .winner');
        self.progressValue = self.progressValue + PROGRESS_UPDATE[self.currentImageIndex];
        self._switchWinnerImage($winners);
      }, 1500);
    },
    _switchWinnerImage(winnersList) {
      hidePreviousWinner(winnersList, this.currentImageIndex);
      showNextWinner(this.currentImageIndex);

      if (this.currentImageIndex === winnersList.length - 1) {
        clearInterval(this.interval);

        this.calculatingProcess2 = true;
      }

      this.currentImageIndex = this.currentImageIndex + 1;
    },
    submitToAPI: function() {
      const self = this;
      try {
        const data = mapFullStoreToParams(self.$store.state.nyop);
        if (isEmptyData(data)) {
          alertAndRedirectToFunnelUrl(data);
          self.calculatingProcess1 = false;
          return;
        }
        $.ajax({
          type: 'POST',
          url: POST_API_URL,
          data: JSON.stringify(data),
          contentType: 'application/json; charset=utf-8',
          success: function(data, status) {
            if (status !== 'success') {
              alert(GENERIC_ERROR_MSG);
              window.Sentry.captureException(data);
            }
          },
          error: function(e) {
            alert(GENERIC_ERROR_MSG);
            window.Sentry.captureException(e);
          },
          complete: function() {
            self.calculatingProcess1 = true;
          }
        });
      } catch (error) {
        self.calculatingProcess1 = true;
      }
    }
  }
}

function hidePreviousWinner(list, index) {
  const positionToHide = index === 0 ? list.length - 1 : index - 1;
  document.querySelectorAll('.winners .winner').item(positionToHide).classList.add('hidden')
}

function showNextWinner(index) {
  document.querySelectorAll('.winners .winner').item(index).classList.remove('hidden')
}

</script>
